import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Grid2 } from "@mui/material";
import axios from "axios";
import { XMLParser } from "fast-xml-parser";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let envs = ["Live", "Staging"];
let regions = ["ne", "cat", "phx"];
let series = [];

function FlippAds(mode) {
	const [focusEnv, setFocusEnv] = React.useState();
	const [focusRegion, setFocusRegion] = React.useState();
	const [focusSeries, setFocusSeries] = React.useState();
	const [seriesAPI, setSeriesAPI] = React.useState([]);
	const [regionJSON, setRegionJSON] = React.useState([]);

	React.useEffect(() => {
		loadSeriesAPI();
	}, []);
	React.useEffect(() => {
		console.log("focusSeries", focusSeries);

		if (focusSeries) {
			console.log("running offer data");
			getOfferData(focusSeries);
		}
	}, [focusSeries]);

	async function getOfferData(json) {
		console.log("getOfferData");
		// console.log(json.listings);
		// console.log(seriesAPI.length);

		for (let i = 0; i < seriesAPI.length; i++) {
			// console.log(seriesAPI[i].model, focusSeries);
			// console.log(seriesAPI[i].model == focusSeries);
			// console.log("jason");
			document.getElementById("ads").innerHTML = "";
			if (seriesAPI[i].id == focusSeries) {
				// console.log("jason2");
				//clear all tags in ads

				//for (var u = 0; u < seriesAPI[i].image.length; u++) {
				//loadImages(seriesAPI[i]);

				var image = document.createElement("img");
				var image2 = document.createElement("img");
				var adDiv = document.createElement("div");
				var adA = document.createElement("a");
				adA.href = seriesAPI[i].product_link.replace(/&#x24;/g, "$");
				adA.target = "_blank";
				adDiv.appendChild(adA);
				adDiv.classList.add("fbCatAdDiv");

				image.src = seriesAPI[i].image_link;

				image.classList.add("fbCatImg");

				document.getElementById("ads").appendChild(adDiv);
				adA.appendChild(image);
				if (seriesAPI[i].image_link2) {
					image2.src = seriesAPI[i].image_link2;
					image2.classList.add("fbCatImg");
					adA.appendChild(image2);
				}
				//}
				//if fbCatMetaDiv exists already remove it
				if (document.getElementById("fbCatMetaDiv")) {
					document.getElementById("fbCatMetaDiv").remove();
				}

				var metaDiv = document.createElement("div");

				metaDiv.id = "fbCatMetaDiv";
				metaDiv.innerHTML += datacombine(
					seriesAPI[i].product_title,
					"product_title"
				);

				metaDiv.innerHTML += datacombine(
					seriesAPI[i].product_description,
					"product_description"
				);
				metaDiv.innerHTML += datacombine(seriesAPI[i].id, "Vehicle Offer ID");

				metaDiv.innerHTML += datacombine(
					seriesAPI[i].product_link,
					"product_link"
				);

				document.getElementById("ads").append(metaDiv);
				return;
			}
			document.getElementById("ads").innerHTML =
				"<h1>Sorry, no data found</h1>";
		}
	}
	function datacombine(data, label) {
		var html = "";

		if (data || data == 0) {
			// if data is an array
			if (Array.isArray(data)) {
				for (var i = 0; i < data.length; i++) {
					html += `<span><b>${label}:</b> ${data[i]}</span>`;
				}
			} else {
				html = `<span><b>${label}:</b> ${data}</span>`;
			}
		} else {
			html = `<span class="fbdataerror"><b>${label}:</b> ${data} is missing</span>`;
		}
		return html;
	}
	async function loadSeriesAPI() {
		const response = await fetch(
			`https://dat-sync.com/assets/se/social/facebook/facebook_automated_catalog_ads/metaInstaCatalog/catalog-xml/ne_flipp.xml`
		);
		/*
		<listing>
        <id>Trade-In_1_1759344554</id>
        <sku></sku>
        <product_title>Trade-In</product_title>
        <product_description>Trade-In</product_description>
        <product_link>https://servedby.flashtalking.com/click/8/290251;9949433;50126;211;0/?ft_width=1&amp;ft_height=1&amp;gdpr=${GDPR}&amp;gdpr_consent=${GDPR_CONSENT_78}&amp;us_privacy=${US_PRIVACY}&amp;url=42920623</product_link>
        <image_link>
            https://dat-sync.com/assets/se/social/facebook/facebook_automated_catalog_ads/metaInstaCatalog/catalog-images/1759344554/ne/other/Trade-In1.jpg</image_link>
        <availability></availability>
        <regular_price></regular_price>
        <sale_price></sale_price>
        <google_product_category></google_product_category>
        <product_category></product_category>
        <brand></brand>
    </listing>
	*/

		//parse the response xml to json
		const text = await response.text();
		const parser = new XMLParser();
		const data = parser.parse(text);

		console.log(data.listings.listing);
		setSeriesAPI(data.listings.listing);
	}

	return (
		<div id="htmlPage">
			<h1>Flipp Ads</h1>
			<Grid2 container spacing={2} direction="column">
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="series-select-label">Series</InputLabel>
					<Select
						labelId="series-select-label"
						id="series-select"
						value={focusSeries ? focusSeries : ""}
						onChange={(e) => setFocusSeries(e.target.value)}
						input={<OutlinedInput label="Series" />}
						MenuProps={MenuProps}
					>
						{seriesAPI
							? seriesAPI.map((listing) => (
									<MenuItem key={listing.id} value={listing.id}>
										<ListItemText primary={listing.product_title} />
									</MenuItem>
							  ))
							: null}
					</Select>
				</FormControl>
			</Grid2>
			<Grid2 container spacing={2} id="ads"></Grid2>
		</div>
	);
}

export default FlippAds;
